import "./confirm-delete-project-pane.styl"
import template from "./confirm-delete-project-pane.pug"
import { ModalPane } from "@/lib/components/modals/modal-pane"
import { modalManager } from "@/lib/managers/modal-manager"

export class ConfirmDeleteProjectPaneViewModel extends ModalPane
   constructor: (projectName) ->
      assertArgs(arguments, String)
      super("Delete Project", "", template())
      @projectName = projectName
      @confirmationText = ko.observable()
      @canDelete = ko.pureComputed =>
         return unless @confirmationText()?
         return @confirmationText().toLowerCase() == "yes"

   confirmDelete: ->
      return unless @canDelete()
      modalManager.modalFinished()
